import styled from 'styled-components';

import COLOR from '../../../utils/colors.constants';

const Title = styled.h1`
  margin: 15px 0;
  padding-top: 10px;  
  text-align: center;
  color: ${COLOR.AZUL};
`;

export default Title;
